import { Paper } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import AdView from "../../components/ui/AdView";
import { Ad_RefreshKey, DialogMessageState, IsBottomLoading } from "../../recoil/states";
import { CommunityBoardRegActions } from "../../reducers/CommunityBoardRegReducer";
import { AppDispatch, RootState } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";
import SearchForm from "./SearchForm";

const BoardList = () => {

    const { MEM_UDID } = useSelector((state: RootState) => state.LoginBtnsReducer.asyncIsLogin); // '로그인 / 로그아웃' 버튼 표시 처리를 위한 state
    const communityBoardListReducer_Result = useSelector((state: RootState) => state.CommunityBoardListReducer); // 게시물 목록 표시 처리를 위한 state
    const setDialogMessageState = useSetRecoilState(DialogMessageState); // 다이얼로그 메세지 요청 정보를 갖는 state
    const [isBottomLoading, setIsBottomLoading] = useRecoilState(IsBottomLoading); // 바닥 로딩바 표시 처리를 위해 사용되는 state
    const ad_RefreshKey = useRecoilValue(Ad_RefreshKey); // 광고 UI 랜더링 처리를 위해 사용되는 state
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (communityBoardListReducer_Result.status !== "LOADING") {
            setIsBottomLoading(true); // 바닥 로딩바 표시 처리
        }
    }, [communityBoardListReducer_Result.status]);

    const boardSeq = CommonUtil.getQuerystring("board_seq", ""); // 게시물 고유번호

    useEffect(() => {

        if (communityBoardListReducer_Result.status === "") {
            // 게시물 목록 > 최초 진입 일 경우

            const curr_page = parseInt(CommonUtil.getQuerystring("curr_page", "1"), 10);
            renderCommunityBoardList(curr_page); // 게시물 목록 가져오기
        }
        else if (communityBoardListReducer_Result.status === "LOADING") {
            // 게시물 목록 > 통신 중 일 경우
        }
        else if (communityBoardListReducer_Result.status === "FAIL") {
            // 게시물 목록 > 통신 실패된 경우

            const message = "게시물 목록 가져오기 실패, 통신 처리 중 알 수 없는 오류가 발생하였습니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
        }
        else if (communityBoardListReducer_Result.status === "COMPLETE") {
            // 게시물 목록 > 통신 성공된 경우

            if (communityBoardListReducer_Result.n4ErrorCode !== 0) {
                // 에러가 발생한 경우

                const message = communityBoardListReducer_Result.strErrorMessage;
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else {
                // 정상인 경우

                CommonUtil.scrollTo("#div_sub_title_ui", 0, 0); // 게시판 상단 영역으로 스크롤바 자동 이동
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [communityBoardListReducer_Result]);

    /**
    * 게시물 목록 가져오기
    * 
    * @param curr_page 페이지 번호
    * @returns 
    */
    const renderCommunityBoardList = (curr_page: number, is_page_click: boolean = false) => {

        const req = CommonUtil.getQuerystring("req", "");
        if (req === "R") return; // '작성하기' 화면에서 새로고침을 진행한 경우, 아래 로직 skip!

        const search_type = CommonUtil.getQuerystring("search_type", "");
        const search_keyword = CommonUtil.getQuerystring("search_keyword", "");
        const sub_menu = CommonUtil.getQuerystring("sub_menu", "");
        const board_seq = is_page_click ? "" : CommonUtil.getQuerystring("board_seq", "");

        let query_string = "&curr_page=" + encodeURIComponent(curr_page)
            + (search_type === "" ? "" : "&search_type=" + encodeURIComponent(search_type))
            + (search_keyword === "" ? "" : "&search_keyword=" + encodeURIComponent(search_keyword))
            + (sub_menu === "" ? "" : "&sub_menu=" + encodeURIComponent(sub_menu))
            + (sub_menu === "" ? "" : "&sub_menu=" + encodeURIComponent(sub_menu))
            + (board_seq === "" ? "" : "&board_seq=" + encodeURIComponent(board_seq))
            ;
        if (query_string !== "") query_string = "?" + query_string.substring(1);

        const url: string = "/community_board_list" + query_string;
        (window as any).urlChange(url);
    }

    /**
    * 게시물 상세 링크 클릭 이벤트 
    * 
    * @param {React.MouseEvent<HTMLTableRowElement, MouseEvent>} e 이벤트 객체
    * @param {string} board_seq 게시물 고유번호
    * @returns {void}
    */
    const handlerBoardDetail = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>, board_seq: string): void => {

        $("#tbody_board_list").find("td").css("background", "");
        $(e.currentTarget).find("td").css("background", "#dfdfdf");

        const curr_page = CommonUtil.getQuerystring("curr_page", "");
        const search_type = CommonUtil.getQuerystring("search_type", "");
        const search_keyword = CommonUtil.getQuerystring("search_keyword", "");
        const sub_menu = CommonUtil.getQuerystring("sub_menu", "");

        let query_string = (curr_page === "" ? "" : "&curr_page=" + encodeURIComponent(curr_page))
            + (search_type === "" ? "" : "&search_type=" + encodeURIComponent(search_type))
            + (search_keyword === "" ? "" : "&search_keyword=" + encodeURIComponent(search_keyword))
            + (sub_menu === "" ? "" : "&sub_menu=" + encodeURIComponent(sub_menu))
            + (board_seq === "" ? "" : "&board_seq=" + encodeURIComponent(board_seq))
            ;
        if (query_string !== "") query_string = "?" + query_string.substring(1);

        const url: string = "/community_board_list" + query_string;
        (window as any).urlChange(url);
    }

    /**
    * 작성하기 버튼 클릭 이벤트 
    * 
    * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
    * @returns {void}
    */
    const handlerBoardReg = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();

        if (MEM_UDID === "") {
            const message = "로그인 후 이용 가능합니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            return;
        }

        dispatch(CommunityBoardRegActions.setInitStatus()); // 최초 진입 시, 상태 값 초기화 (이렇게 하지 않으면 이전 상태 값이 남아있어서 오동작 함!)

        (window as any).urlChange("/community_board_list?req=R&prev_url=" + encodeURIComponent(window.location.pathname + window.location.search)); // url 주소 변경
    }

    /**
    * 페이징 버튼 클릭 이벤트
    * 
    * @param e 이벤트 객체
    * @param page_no 페이지 번호
    * @returns 
    */
    const moveBoardPage = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, page_no: number) => {
        e.preventDefault();

        (window as any).isPageMove = true; // 페이지 이동 알림

        setIsBottomLoading(false); // 바닥 로딩바 숨김 처리
        renderCommunityBoardList(page_no, true);// 게시물 목록 가져오기
    }

    /**
    * 게시물 목록 페이징 UI 생성
    * 
    * @param totalData 검색된 총 데이터 개수
    * @param dataPerPage 한 페이지 당 최대 표시 개수
    * @param pageCount 페이징 컨트롤 UI 상 최대 페이지 번호 표시 개수
    * @param currentPage 현재 페이지 번호
    * @returns 페이지 컨트롤 jsx 반환
    */
    const createPagingControl = (totalData: number, dataPerPage: number, pageCount: number, currentPage: number) => {

        if (totalData === 0) {
            return "";
        }

        if (CommonUtil.isMobileOs()) pageCount = 5; // 모바일 기기일 경우, 페이지 번호 최대 5개까지만 표시

        var totalPage = Math.ceil(totalData / dataPerPage);    // 총 페이지 수
        var pageGroup = Math.ceil(currentPage / pageCount);    // 페이지 그룹

        var last = pageGroup * pageCount;    // 화면에 보여질 마지막 페이지 번호
        if (last > totalPage)
            last = totalPage;
        var first = last - (pageCount - 1);    // 화면에 보여질 첫번째 페이지 번호
        if (first < 1) first = 1;

        //var next = last + 1;
        var prev = first - 1;
        var end = Math.floor((totalData / dataPerPage) + ((totalData % dataPerPage === 0) ? 0 : 1));

        var pages = [];
        for (var i = first; i <= last; i++) {
            pages.push(i);
        }

        return (
            <nav className="pg_wrap" style={{ width: "100%" }}>
                <span className="pg" id="span_page_ui">
                    {
                        currentPage !== 1 ?
                            <a href="#none" id="first" onClick={e => moveBoardPage(e, 1)} style={{ marginRight: "10px", textDecoration: "none" }}><i className="fa fa-backward" aria-hidden="true"></i> </a>
                            : ""
                    }
                    {
                        prev > 0 ?
                            <a href="#none" id="prev" onClick={e => moveBoardPage(e, communityBoardListReducer_Result.currPage - 1)} style={{ marginRight: "10px", textDecoration: "none" }}><i className="fa fa-step-backward" aria-hidden="true"></i> </a>
                            : ""
                    }
                    {
                        pages.map((item, idx) => <a href="#none" key={idx} onClick={e => { item === communityBoardListReducer_Result.currPage ? e.preventDefault() : moveBoardPage(e, item) }} style={{ textDecoration: "none" }} className={item === communityBoardListReducer_Result.currPage ? "pg_current" : "pg_page"}>{item}</a>)
                    }
                    {
                        last !== totalPage ?
                            <a href="#none" id="next" onClick={e => moveBoardPage(e, communityBoardListReducer_Result.currPage + 1)} style={{ marginLeft: "10px", textDecoration: "none" }}><i className="fa fa-step-forward" aria-hidden="true"></i> </a>
                            : ""
                    }
                    {
                        end !== currentPage ?
                            <a href="#none" id="end" onClick={e => moveBoardPage(e, communityBoardListReducer_Result.n4TotalPage)} style={{ marginLeft: "10px", textDecoration: "none" }}><i className="fa fa-forward" aria-hidden="true"></i> </a>
                            : ""
                    }
                </span>
            </nav>
        )
    }

    const addStyle = { background: "#dfdfdf" };

    if (
        (communityBoardListReducer_Result.status === "LOADING" || communityBoardListReducer_Result.status === "FAIL") &&
        isBottomLoading // 바닥 로딩바 표시 처리된 경우
    ) {

        return (
            <p id="p_reply_loading" className="bo_vc_empty">
                <img src="/images/ajax-loader-2.gif" alt="" /><br /><br />게시물 목록을 가져오는 중입니다..
            </p>
        );
    }
    else {
        return (
            <div id="div_list_ui" className="bo_list community_ele_hide" style={{ textAlign: "center" }}>

                <AdView googleAdsense={{ rootid: "adsense_Ad_Web_Root_3", slot: "3048751581", height: CommonUtil.isMobileOs() ? 50 : 100 }}
                    kakaoAdfit={{ rootid: "kakao_Ad_Web_Root_3", unit: "DAN-sl8z3s0dvwip", width: 320, height: 50 }}
                    marginStyle="10px 0 0"
                    refreshKey={ad_RefreshKey}
                />

                <div className="bo_btn_top" style={{ width: "100%" }}>
                    <div className="bo_list_total">
                        전체 <span id="span_total_ui">{communityBoardListReducer_Result.n4TotalCount}</span> 건
                    </div>

                </div>

                {
                    communityBoardListReducer_Result.LIST.length === 0 ?
                        <p id="p_community_board_loading" className="bo_vc_empty">
                            등록된 게시물이 없습니다.
                        </p>
                        :
                        <div className="tbl_head01 tbl_wrap" style={{ width: "100%" }}>
                            <table style={{ tableLayout: "fixed" }}>
                                <caption>게시판 목록</caption>
                                <thead>
                                    <tr>
                                        <Paper sx={{ display: { lg: "table-cell", xs: "none" } }} elevation={0} component="th" scope="col" style={{ width: "80px" }} className="custom_community_board_no">No.</Paper>
                                        <th scope="col">제목</th>
                                        <th scope="col" style={{ width: "100px" }}>별명</th>
                                        <Paper sx={{ display: { lg: "table-cell", xs: "none" } }} elevation={0} component="th" scope="col" style={{ width: "50px" }} className="custom_community_board_hit">조회수</Paper>
                                        <th scope="col" style={{ width: "75px" }}>등록일</th>
                                    </tr>
                                </thead>
                                <tbody id="tbody_board_list">
                                    {
                                        communityBoardListReducer_Result.LIST?.map((item, idx) => {
                                            return (
                                                <tr style={{ cursor: "pointer" }} onClick={e => handlerBoardDetail(e, item.UCBM_BOARD_SEQ)} key={idx}>
                                                    <Paper sx={{ display: { lg: "table-cell", xs: "none" } }} elevation={0} component="td" className="td_num2 custom_community_board_no" style={item.UCBM_BOARD_SEQ === boardSeq ? addStyle : {}}>{item.V_NO}</Paper>
                                                    <td className="td_subject" style={Object.assign({ paddingLeft: "0px" }, item.UCBM_BOARD_SEQ === boardSeq ? addStyle : {})}>
                                                        <Paper elevation={0} component="div" className={`bo_tit ${(item.UCBM_COMMENT_COUNT > 0 || item.UCBM_IMG_PATH !== "") ? " comment_exist" : ""}`}
                                                            sx={{
                                                                // 말줄임 스타일
                                                                maxWidth: { lg: "80%", xs: item.UCBM_IMG_PATH !== "" || item.UCBM_COMMENT_COUNT > 0 ? "65%" : "100%" },
                                                                overflow: "hidden",
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: "vertical",
                                                                backgroundColor: "transparent"
                                                            }}
                                                            dangerouslySetInnerHTML={{ __html: item.UCBM_TITLE }}
                                                        >
                                                        </Paper>
                                                        {item.UCBM_IMG_PATH !== "" ? <>&nbsp;<span style={{ color: "#68b880", display: "inline-block", verticalAlign: "top" }}><i className="fa fa-file-image-o" aria-hidden="true"></i></span></> : ""}
                                                        {item.UCBM_COMMENT_COUNT > 0 ? <>&nbsp;<span style={{ color: "#ff762d", display: "inline-block", verticalAlign: "top" }}><i className="fa fa-commenting" aria-hidden="true" ></i > ({item.UCBM_COMMENT_COUNT > 99 ? "99+" : item.UCBM_COMMENT_COUNT})</span></> : ""}
                                                    </td>
                                                    <td className="td_name sv_use" style={item.UCBM_BOARD_SEQ === boardSeq ? addStyle : {}}>
                                                        {item.UCBM_ANONYMOUS_YN === "Y" ? <div className="nickname_ui anonymous">익명</div> : <div className="nickname_ui">{item.UCBM_REG_NICKNAME}</div>}
                                                    </td>
                                                    <Paper sx={{ display: { lg: "table-cell", xs: "none" } }} elevation={0} component="td" className="td_num custom_community_board_hit" style={item.UCBM_BOARD_SEQ === boardSeq ? addStyle : {}}>{item.UCBM_HIT_COUNT > 9999 ? "9999+" : item.UCBM_HIT_COUNT}</Paper>
                                                    <td className="td_datetime" style={item.UCBM_BOARD_SEQ === boardSeq ? addStyle : {}}>{item.UCBM_REG_DT}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <AdView googleAdsense={{ rootid: "adsense_Ad_Web_Root_4", slot: "6888047959", height: CommonUtil.isMobileOs() ? 50 : 100 }}
                    kakaoAdfit={{ rootid: "kakao_Ad_Web_Root_4", unit: "DAN-1jefgcge7qp9f", width: 320, height: 50 }}
                    marginStyle="0 0 10px"
                    refreshKey={ad_RefreshKey}
                />

                <SearchForm />
                <div>
                    <a id="anchor_Board_Reg" className="btn_submit" style={{ margin: "0px" }} href="#" onClick={handlerBoardReg}>작성하기</a>
                </div>

                <nav className="pg_wrap" style={{ width: "100%" }}>
                    <span className="pg" id="span_page_ui">
                        {createPagingControl(communityBoardListReducer_Result.n4TotalCount, parseInt(process.env.REACT_APP_COMMUNITY_BOARD_PAGE_SIZE as string, 10), 10, communityBoardListReducer_Result.currPage)}
                    </span>
                </nav>
            </div>
        )
    }
}

export default BoardList;
